var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97266 1.91406C9.97266 2.16406 9.88281 2.37891 9.70312 2.55859C9.52344 2.73828 9.30859 2.82812 9.05859 2.82812C8.80859 2.82812 8.59375 2.73828 8.41406 2.55859C8.23438 2.37891 8.14453 2.16406 8.14453 1.91406C8.14453 1.66016 8.23438 1.44531 8.41406 1.26953C8.59375 1.08984 8.80859 1 9.05859 1C9.30859 1 9.52344 1.08984 9.70312 1.26953C9.88281 1.44531 9.97266 1.66016 9.97266 1.91406ZM8.98828 7.69141H9.58008C9.08008 8.75781 8.38086 9.29102 7.48242 9.29102C7.11914 9.29102 6.8457 9.21484 6.66211 9.0625C6.47852 8.91016 6.38672 8.68359 6.38672 8.38281C6.38672 8.20703 6.46289 7.89844 6.61523 7.45703L7.31836 5.43555C7.37305 5.2793 7.40039 5.17773 7.40039 5.13086C7.40039 5.08398 7.38867 5.05078 7.36523 5.03125C7.3457 5.00781 7.3125 4.99609 7.26562 4.99609C7.06641 4.99609 6.83203 5.25 6.5625 5.75781H6C6.50391 4.66797 7.21484 4.12305 8.13281 4.12305C8.45703 4.12305 8.70898 4.20312 8.88867 4.36328C9.06836 4.51953 9.1582 4.73633 9.1582 5.01367C9.1582 5.2168 9.07812 5.53906 8.91797 5.98047L8.23828 7.83203C8.14062 8.09375 8.0918 8.25781 8.0918 8.32422C8.0918 8.36719 8.10352 8.40039 8.12695 8.42383C8.1543 8.44727 8.19141 8.45898 8.23828 8.45898C8.33984 8.45898 8.46875 8.37109 8.625 8.19531C8.78516 8.01953 8.90625 7.85156 8.98828 7.69141Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.25781H6.50297L6.14298 7.29277L6.14259 7.29391C5.99262 7.72843 5.88672 8.11189 5.88672 8.38281C5.88672 8.79021 6.01586 9.17597 6.34282 9.44728C6.65262 9.70434 7.06085 9.79102 7.48242 9.79102C8.63759 9.79102 9.48095 9.08063 10.0328 7.90367L10.3667 7.19141H9.58008H9.00607L9.38734 6.15277L9.38735 6.15277L9.38799 6.15101C9.54877 5.70787 9.6582 5.31267 9.6582 5.01367C9.6582 4.61895 9.52475 4.25504 9.21907 3.98799C8.92038 3.723 8.53561 3.62305 8.13281 3.62305C6.95715 3.62305 6.10175 4.34635 5.54616 5.54797L5.21796 6.25781H6ZM10.0567 2.91215C10.3284 2.64042 10.4727 2.2991 10.4727 1.91406C10.4727 1.52809 10.3304 1.18466 10.0547 0.91404C9.78333 0.643569 9.44272 0.5 9.05859 0.5C8.67447 0.5 8.33386 0.643569 8.06245 0.91404C7.78681 1.18466 7.64453 1.52809 7.64453 1.91406C7.64453 2.2991 7.78879 2.64042 8.06051 2.91215C8.33223 3.18387 8.67355 3.32812 9.05859 3.32812C9.44363 3.32812 9.78496 3.18387 10.0567 2.91215Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.436035,
    y: 0,
    width: 14.7175,
    height: 18.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.f140ae9d35e1c4eeea6318385d3f8fcf.svg";
export { ForwardRef as ReactComponent };